module.exports = __webpack_public_path__ + "img/btn.d3becdcb.png";